module.exports = __webpack_public_path__ + "img/readlater.67005dbd.png";